import { render, staticRenderFns } from "./UpgradeLog.vue?vue&type=template&id=280b6e6e&scoped=true&"
import script from "./UpgradeLog.vue?vue&type=script&lang=js&"
export * from "./UpgradeLog.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeLog.vue?vue&type=style&index=0&id=280b6e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b6e6e",
  null
  
)

export default component.exports